var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('el-tree',{ref:"dialogtree",attrs:{"props":_vm.properties,"load":_vm.loadNode,"node-key":_vm.nodeKey,"lazy":"","highlight-current":"","default-expanded-keys":_vm.defaultExpandedKeys,"expand-on-click-node":false,"render-content":_vm.renderContent},on:{"node-click":_vm.handleNodeClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }